import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';

import {ErrorService, EventService} from '..';
import {Customer} from '../models/customer';
import {ConfigService} from './config.service';
import {CrashReport, CrashReportResponse} from '../models/crashreport';


@Injectable({providedIn: 'root'})
export class CrashReportService {
    private crashReportURL = ConfigService.getApiEndpoint() + 'v1/crashreport/';

    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) {
    }

    search(query: any): Observable<CrashReportResponse> {

        return this.http.get<CrashReportResponse>(this.crashReportURL + 'search', {params: query}).pipe(
            catchError(this.error.handleError('search', null))
        );
    }


    update( reporterId:String, crashReport: CrashReport): Observable<CrashReport> {
        // return of(CustomerMock);
        return this.http.put<Customer>(this.crashReportURL + reporterId, crashReport).pipe(
            tap(_ => this.eventService.addAlert(`updated crashReport: ${crashReport.id}`)),
            catchError(this.error.handleError('crashReport', null))
        );
    }

    geCrashReport(crashReportId: string): void {
        this.http.get(this.crashReportURL + crashReportId + '/report', {responseType: 'blob'})
            .subscribe(blob => {
                    this.downloadData(crashReportId + '.zip', window.URL.createObjectURL(blob));
                },
                error => {
                    this.error.handleError('download.crashreport', null);
                });
    }

    /**
     * opens the saveFile dialog with the given objectUrl
     * @param name the target name of the file
     * @param objectUrl the content of the file
     */
    private downloadData(name: string, objectUrl: string) {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = objectUrl;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(objectUrl);
    }

}
